import React from 'react';

import { getValidations } from '.';

export const validateInputs = (
    inputs: Input[],
): {
    hasValidationErrors: boolean;
    validationOutputs: ValidationOutput[];
} => {
    const validations = getValidations(inputs);
    const validationOutputs = [] as ValidationOutput[];
    let hasValidationErrors = false;

    validations.reduce(
        (
            acc: ValidationOutput[],
            validation: Validation,
        ): ValidationOutput[] => {
            const { inputId, label, type, ruleResults, isValid } = validation;

            if (isValid) {
                return acc;
            }

            if (!isValid) {
                hasValidationErrors = true;
            }

            if (ruleResults.length === 1) {
                const markup = <span>{`${ruleResults[0].errorMessage}.`}</span>;

                acc.push({ inputId, label, type, markup, singular: true });
            } else {
                const markup = (
                    <div key={type}>
                        {ruleResults.map(
                            (ruleResult: RuleResult): JSX.Element => {
                                const { valid, errorMessage, name } =
                                    ruleResult;

                                return (
                                    <div key={name} className="text-sm">
                                        <input
                                            type="checkbox"
                                            id={name}
                                            checked={valid}
                                            readOnly
                                        />
                                        <span className="pl-2">
                                            {errorMessage}
                                        </span>
                                    </div>
                                );
                            },
                        )}
                    </div>
                );

                acc.push({ inputId, label, type, markup, singular: false });
            }

            return acc;
        },
        validationOutputs,
    );

    return {
        hasValidationErrors,
        validationOutputs,
    };
};
